import type { ResponseEvent } from "@/hooks/useResponseEvents"

/** What the Events tab hands to Compose through router state. */
export interface ComposeDraft {
  to: string
  subject: string
  body: string
  template: ResponseEvent["response_id"]
  /** What the response is about: re-checked at send and used for prior-contact history. */
  templateRef: string
  context: {
    responseName: string
    who: string
    link: string
    linkNote: string
    /** ISO time of an earlier send of this response for this reference, if any. */
    handledAt: string | null
  }
}

export function draftFromEvent(e: ResponseEvent): ComposeDraft {
  return {
    to: e.email,
    subject: e.subject,
    body: e.body,
    template: e.response_id,
    templateRef: e.template_ref,
    context: {
      responseName: e.response_name,
      who: e.name ?? e.email,
      link: e.link,
      linkNote: e.link_note,
      handledAt: e.handled_at,
    },
  }
}
